// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TysiaNotificationBadge from './view'

export default function TysiaNotificationBadgeFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TysiaNotificationBadge">
      <TysiaNotificationBadge {...props}>
        {children}
      </TysiaNotificationBadge>
    </Flow>
  )
}
